import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import urls, { VERSIONS } from '../constants/urls';
import * as services from '../constants/apiServices';
import { parseQueryString } from './queryStringParameters';

const superagent = superagentPromise(_superagent, global.Promise);

const responseBody = response => response.body;

export const getSiteCode = sitecode => {
	const parts = (sitecode || '').split('@');
	const newSiteCode = parts.slice(0, 1).shift();
	return newSiteCode || null;
};

export const getEnvironment = sitecode => {
	const parts = (sitecode || '').split('@');
	const env = parts.slice(1, 2).shift();
	return env || 'production';
};

export const getEnvironmentFromUrl = (url, queryString) => {
	var params = parseQueryString(queryString);
	let environment = "production"; // Default to production.

	if(url.includes("rcapp") || params["env"] === "rc"){
		environment = "rc";
	} else if(url.includes("testapp") || params["env"] === "test"){
		environment = "test";
	} else if(params["env"] === "development"){
		environment = "development";
	}

	return environment;
}

export const getUrlFromMap = urlMap => (service, environment) => {
	const env = environment ? environment.toLowerCase() : 'production';
	return (urlMap[env] || urlMap.production)[service];
};

export const getUrl = getUrlFromMap(urls);

export const getServiceVersionFromMap = versionMap => (service, environment) => {
	const env = environment ? environment.toLowerCase : 'production';
	return (versionMap[env] || versionMap.production)[service];
};

export const getServiceVersion = getServiceVersionFromMap(VERSIONS);

export const getLoggerUrl = environment => getUrl(services.logger, environment);

export const getAuthUrl = environment => getUrl(services.auth, environment);

export const getManagerUrl = environment => getUrl(services.manager, environment);

export const getSequencerUrl = environment => getUrl(services.sequencer, environment);

export const getPortalUrl = environment => getUrl(services.portal, environment);

export const getSupportUrl = environment => getUrl(services.support, environment);

const post = superagent => (url, type, data) => {
	return superagent
		.post(url)
		.type(type)
		.send(data)
		.then(responseBody);
};

const get = superagent => (url) => {
	return superagent
		.get(url)
		.then(responseBody);
};

const getWithAuth = superagent => (url, data) => {
	return superagent
		.get(url)
		.set(data)
		.then(responseBody);
};

// Define the service
const http = {
	post: post(superagent),
	get: get(superagent),
	getWithAuth: getWithAuth(superagent)
};

export default http;



// WEBPACK FOOTER //
// ./src/services/network.js